module.exports = __webpack_public_path__ + "static/media/CybersecurityCertif.a9b737bf.png";